import comp from "./AcademicYearFilter";
export default comp;
